<div class="task-heat-map" *ngIf="rows.length">
    <div class="heat-grid" [style.grid-template-columns]="gridTemplateColumns">
        <div class="heat-corner">
            <button type="button" class="col-label" (click)="toggleNameSort()" aria-label="Sort by task name">Task Name</button>
            <span class="sort-arrows">
                <button
                    type="button"
                    class="sort-arrow"
                    [class.active]="nameSortDirection === 'asc'"
                    (click)="sortByName('asc')"
                    aria-label="Sort task name A to Z"
                >&#9650;</button>
                <button
                    type="button"
                    class="sort-arrow"
                    [class.active]="nameSortDirection === 'desc'"
                    (click)="sortByName('desc')"
                    aria-label="Sort task name Z to A"
                >&#9660;</button>
            </span>
        </div>
        <div class="heat-col-header" *ngFor="let column of columnLabels; let ci = index">
            <button type="button" class="col-label" (click)="toggleSort(ci)" [attr.aria-label]="'Sort by ' + column">{{ column }}</button>
            <span class="sort-arrows">
                <button
                    type="button"
                    class="sort-arrow"
                    [class.active]="sortColumnIndex === ci && sortDirection === 'desc'"
                    (click)="sortByColumn(ci, 'desc')"
                    [attr.aria-label]="'Sort ' + column + ' largest first'"
                >&#9650;</button>
                <button
                    type="button"
                    class="sort-arrow"
                    [class.active]="sortColumnIndex === ci && sortDirection === 'asc'"
                    (click)="sortByColumn(ci, 'asc')"
                    [attr.aria-label]="'Sort ' + column + ' lowest first'"
                >&#9660;</button>
            </span>
        </div>
        <ng-container *ngFor="let row of rows">
            <div
                class="heat-row-header"
                matTooltipPosition="below"
                matTooltipClass="chart-info-tooltip"
                [matTooltip]="row.label"
            >{{ row.label }}</div>
            <div
                class="heat-cell"
                *ngFor="let cell of row.cells"
                [style.background-color]="cell.color"
                [style.color]="cell.textColor"
                matTooltipPosition="below"
                matTooltipClass="chart-info-tooltip"
                [matTooltip]="cell.tooltip"
            >{{ cell.full }}</div>
        </ng-container>
    </div>
</div>
